export default __webpack_public_path__ + "static/media/abld_science.1e0853f6fdef3f6d9653304e161dfd2b.svg";